import React from "react";
import { PhoneMissed, TrendingUp, Ghost, CircleAlert } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ElProblemaDeLaInvisibilidad() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const painPoints = [{
    icon: PhoneMissed,
    title: "No recibe carga",
    description: "Si al conectar el cargador la luz no cambia, el BMS o las celdas podrían estar bloqueadas. Es el fallo más común en modelos Xiaomi y Cecotec que reparamos en Sevilla, Mairena del Aljarafe y el Aljarafe."
  }, {
    icon: TrendingUp,
    title: "Se apaga en cuestas",
    description: "Tu batería marca carga, pero se desconecta al pedirle potencia. Este desequilibrio crítico requiere un equilibrado profesional en nuestro taller especializado de Sevilla y Mairena del Aljarafe."
  }, {
    icon: Ghost,
    title: "Autonomía fantasma",
    description: "¿Los kilómetros desaparecen en minutos? Las celdas sufren por el calor extremo de Sevilla y el Aljarafe. Reconstruimos tu batería para que recupere su potencia y autonomía original."
  }];
  return <section data-section-id="41844" id="tu-batería-no-carga-o-se-apaga" className="dark bg-background text-foreground py-24 px-6 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-[20%] left-[10%] w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[20%] right-[10%] w-96 h-96 bg-chart-2/5 rounded-full blur-3xl" />
      </div>

      <div ref={ref} className={cn("relative container mx-auto max-w-5xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="text-center mb-16 space-y-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-sm bg-primary/10 text-primary text-sm font-default font-medium mb-4 border border-primary/20">
            <CircleAlert className="w-4 h-4" />
            <span>Diagnóstico Técnico</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tighter text-foreground uppercase">
            ¿Tu batería de patinete no carga o se apaga en Sevilla, Mairena o el Aljarafe?
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto leading-relaxed">
            No permitas que un fallo técnico detenga tu movilidad. Si necesitas reparar tu batería de patinete en Sevilla, Mairena del Aljarafe o el Aljarafe, te ofrecemos un diagnóstico preciso y la solución profesional definitiva para recuperar tu autonomía.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {painPoints.map((point, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full bg-card/40 backdrop-blur-xl border-border/40 hover:border-primary/40 rounded-sm transition-colors duration-300 group">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-sm bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                    <point.icon className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-default font-bold text-foreground">
                    {point.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground font-default leading-relaxed">
                    {point.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="flex flex-col items-center text-center space-y-8">
          <div className="flex items-center gap-4 w-full max-w-md">
            <Separator className="flex-1 bg-border/50" />
            <span className="text-sm font-default font-medium text-muted-foreground uppercase tracking-widest">
              La Realidad Técnica
            </span>
            <Separator className="flex-1 bg-border/50" />
          </div>

          <div className="max-w-3xl space-y-6">
            <p className="text-2xl md:text-3xl font-default font-semibold text-foreground">
              No es culpa de tu vehículo, <br className="hidden md:block" />
              <span className="text-muted-foreground">
                es un desgaste natural de la química del litio.
              </span>{" "}
              Este problema es frecuente en Sevilla, Mairena del Aljarafe y el Aljarafe.
            </p>
            
            <Separator className="h-1.5 w-24 bg-primary mx-auto rounded-full my-8 shadow-[0_0_15px_rgba(188,255,51,0.4)]" />

            <p className="text-lg text-foreground/90 font-default font-medium">
              Reparar tu batería puede ahorrarte dinero y alargar su vida útil. Nuestro servicio está disponible en Sevilla, Mairena del Aljarafe y el Aljarafe.
            </p>

            <Link to="https://wa.me/34624990509">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 font-default font-bold rounded-lg shadow-[0_0_15px_rgba(188,255,51,0.4)] px-8 py-6 h-auto text-lg transition-all">
                Solicitar diagnóstico
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}